export default {"src":"/_next/static/image/public/images/ic_other_docs.ce0cdd0d16147a1eb9bfa38124187767.svg","height":50,"width":50};